export default __webpack_public_path__ + "static/media/louise.1d64eed7.jpg";